export default __webpack_public_path__ + "static/media/contact.f94e5fba.png";